import { render, staticRenderFns } from "./TaskColumnCard.vue?vue&type=template&id=6bfea097"
import script from "./TaskColumnCard.vue?vue&type=script&lang=js"
export * from "./TaskColumnCard.vue?vue&type=script&lang=js"
import style0 from "./TaskColumnCard.vue?vue&type=style&index=0&id=6bfea097&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports